import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import { useToast, dismissAllToasts } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()
  const { pathname } = useLocation()

  // Scope a toast to the view that raised it. Without this, an interceptor
  // error from one page follows the user across every subsequent navigation
  // and reads as those pages having failed.
  useEffect(() => {
    dismissAllToasts()
  }, [pathname])

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
